module.exports = "<div  style='text-align: center; height: 450px;'>\r\n  <p>Please wait…</p>\r\n \r\n</div>"